import { requestWithToken } from '../utilities/request';
const path = '/api/private/fields';

const list = (fieldId, param) => {
  return requestWithToken(
    {
      method: 'GET',
      url: path.concat(`/${fieldId}/work_dates`),
      params: param,
    },
    false
  );
};

const update = (fieldId, values) => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/${fieldId}/work_dates`),
    data: values,
  });
};

const recentWorkDate = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}/work_dates/recent_work_date`),
  });
};

export const WorkDatesService = {
  list,
  update,
  recentWorkDate,
};
export default WorkDatesService;



// WEBPACK FOOTER //
// ./src/services/WorkDates.js